import { http } from "../http";

export const getContactsSearchMapViewService = async (
  filters,
  abortController,
) => {
  try {
    const url = "/contacts/search/map-view";
    const response = await http.post(url, filters, {
      baseURL: process.env.BFFV2_BASE_URL,
      signal: abortController?.signal,
    });
    if (!response?.data) {
      throw new Error("Can't get contacts map-view list");
    }
    return response?.data;
  } catch (e) {
    console.error("something went wrong", e);
    throw e;
  }
};

export default {
  getContactsSearchMapViewService,
};
